<script setup lang="ts">
import { useCreditSimulatorAnchor } from '~/composables/credit';

import { CREDIT_BANK_RATES } from '../content';
import { CreditSectionTitle } from '../CreditSectionTitle';

const { scrollToSimulator } = useCreditSimulatorAnchor();

// The lowest rate is highlighted, whatever its position in the list.
const lowestRate = Math.min(
	...CREDIT_BANK_RATES.map(item => parseFloat(item.rate.replace(',', '.')))
);

function isLowest(rate: string): boolean {
	return parseFloat(rate.replace(',', '.')) === lowestRate;
}
</script>

<template>
	<section class="bg-black text-[#FAFAFA]">
		<div class="mx-auto grid max-w-[1288px] lg:grid-cols-2">
			<div class="px-5 pt-16 lg:py-24 lg:pr-16 lg:pl-6">
				<CreditSectionTitle>Taxas de financiamento hoje</CreditSectionTitle>
				<p class="mt-4 mb-0 text-[16px] leading-[1.6] text-[#A3A3A3]">
					Taxas mínimas de cada banco. A taxa final varia conforme seu perfil e
					relacionamento.
				</p>
				<a
					href="#simulador"
					class="mt-7 flex min-h-13 w-full items-center justify-center rounded-xs bg-beige px-8 text-[17px] font-medium text-black no-underline lg:inline-flex lg:w-auto"
					@click.prevent="scrollToSimulator"
				>
					Ver a minha taxa
				</a>
			</div>
			<div class="px-5 py-16 lg:py-24 lg:pr-6 lg:pl-16">
				<table class="w-full border-collapse">
					<caption
						class="pb-9 text-left text-[13px] leading-[1.5] text-[#A3A3A3]"
					>
						SBPE, taxas anuais + TR · referência de out/2026
					</caption>
					<thead>
						<tr
							class="border-b border-[#2A2A2A] text-[13px] tracking-[2px] text-[#A3A3A3] uppercase"
						>
							<th scope="col" class="pb-4 text-left font-normal">Banco</th>
							<th scope="col" class="pb-4 text-right font-normal">
								A partir de
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="item in CREDIT_BANK_RATES"
							:key="item.bank"
							class="border-b border-[#2A2A2A]"
						>
							<th scope="row" class="py-6 text-left text-[20px] font-normal">
								{{ item.bank }}
							</th>
							<td
								:class="[
									'py-6 text-right text-[22px] font-light',
									isLowest(item.rate) ? 'text-beige' : ''
								]"
							>
								{{ item.rate }}
							</td>
						</tr>
					</tbody>
				</table>
				<p class="mt-7 mb-0 text-[13px] leading-[1.5] text-[#A3A3A3]">
					Taxas sujeitas à análise de crédito de cada instituição.
				</p>
			</div>
		</div>
	</section>
</template>
